import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { groupsResourceType } from "./groupsResourceConsts";

export const groupItemIdentifierStruct = createIdentifierStruct(
  groupsResourceType
);
